import { type ComputedRef, computed, useSlots } from 'vue';

export const useSlotValidation = (
	...slotNames: string[]
): ComputedRef<Record<(typeof slotNames)[number], boolean>> => {
	const slots = useSlots();

	return computed<Record<(typeof slotNames)[number], boolean>>(() => {
		const slotCheck: Record<(typeof slotNames)[number], boolean> = {};
		for (const slotName of slotNames) {
			// biome-ignore lint/suspicious/noExplicitAny: Init Biome
			const currentSlot = slots?.[slotName] && (slots[slotName] as any)()[0];
			if (!currentSlot) slotCheck[slotName] = false;
			else if (Array.isArray(currentSlot.children))
				slotCheck[slotName] = currentSlot.children.length > 0;
			else if (typeof currentSlot.children === 'string')
				slotCheck[slotName] = currentSlot.children !== '';
			else slotCheck[slotName] = !!currentSlot.children;
		}
		return slotCheck;
	});
};
